import { render, staticRenderFns } from "./income.vue?vue&type=template&id=68068f10"
import script from "./income.vue?vue&type=script&lang=js"
export * from "./income.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tentacles/servers/appservers/video-admin-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('68068f10')) {
      api.createRecord('68068f10', component.options)
    } else {
      api.reload('68068f10', component.options)
    }
    module.hot.accept("./income.vue?vue&type=template&id=68068f10", function () {
      api.rerender('68068f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/brokerManage/income.vue"
export default component.exports